var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingMenu3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 10,
    fill: "#B6DEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25.4997C31.5 24.8183 31.7726 24.2006 32.2146 23.7497H25.5C24.5335 23.7497 23.75 22.9662 23.75 21.9997V14.0029C18.6188 14.1355 14.5 18.3366 14.5 23.4997C14.5 28.5787 18.4857 32.7268 23.5 32.9868V31.4997C23.5 30.119 24.6193 28.9997 26 28.9997C26.5628 28.9997 27.0822 29.1857 27.5 29.4995V28.4997C27.5 27.119 28.6193 25.9997 30 25.9997C30.5628 25.9997 31.0822 26.1857 31.5 26.4995V25.4997ZM25.25 14.0812V21.9997C25.25 22.1378 25.3619 22.2497 25.5 22.2497H33.4185C32.8603 18.0028 29.4969 14.6394 25.25 14.0812ZM34 24C33.1716 24 32.5 24.6716 32.5 25.5V33.5C32.5 34.3284 33.1716 35 34 35C34.8284 35 35.5 34.3284 35.5 33.5V25.5C35.5 24.6716 34.8284 24 34 24ZM26 30C25.1716 30 24.5 30.6716 24.5 31.5V33.5C24.5 34.3284 25.1716 35 26 35C26.8284 35 27.5 34.3284 27.5 33.5V31.5C27.5 30.6716 26.8284 30 26 30ZM28.5 28.5C28.5 27.6716 29.1716 27 30 27C30.8284 27 31.5 27.6716 31.5 28.5V33.5C31.5 34.3284 30.8284 35 30 35C29.1716 35 28.5 34.3284 28.5 33.5V28.5Z",
    fill: "#3D8DCF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingMenu3);
export default __webpack_public_path__ + "static/media/onboarding-menu-3.5319d774f0183d3c4509973ac100046d.svg";
export { ForwardRef as ReactComponent };